import React, { useState } from 'react';
import { colors, typography, layout, commonStyles } from '../about/News/styles/minimalStyles';
import Button from '../buttons/Buttons';
const ContactForm = () => {
  const [formData, setFormData] = useState({
    workEmail: '',
    firstName: '',
    lastName: '',
    companyName: '',
    jobTitle: '',
    platformUsers: '',
    companyHeadquarters: '',
    message: '',
    marketingConsent: false
  });

  const [formErrors, setFormErrors] = useState({});
  const [isButtonHovered, setIsButtonHovered] = useState(false);
  // Optional: State for input focus styling
  const [focusedField, setFocusedField] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
     // Clear error when user starts typing
    if (formErrors[name]) {
        setFormErrors({ ...formErrors, [name]: null });
    }
  };

  const handleFocus = (e) => {
    setFocusedField(e.target.name);
  };

  const handleBlur = () => {
    setFocusedField(null);
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.workEmail) errors.workEmail = 'Work email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.workEmail))
      errors.workEmail = 'Email address is invalid';

    if (!formData.firstName) errors.firstName = 'First name is required';
    if (!formData.lastName) errors.lastName = 'Last name is required';
    if (!formData.companyName) errors.companyName = 'Company name is required';
    if (!formData.jobTitle) errors.jobTitle = 'Job title is required';
    if (!formData.platformUsers) errors.platformUsers = 'Number of platform users is required';
    if (!formData.companyHeadquarters) errors.companyHeadquarters = 'Company headquarters is required';
    if (!formData.message) errors.message = 'Please tell us more about your use case';
    if (!formData.marketingConsent) errors.marketingConsent = 'Agreement to the policy is required';


    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    setFormErrors(errors); // Update errors state

    if (Object.keys(errors).length === 0) {
      // console.log'Form submitted:', formData);
      alert('Thanks for contacting us! We will get back to you soon.');
      // Reset form
      setFormData({
        workEmail: '', firstName: '', lastName: '', companyName: '',
        jobTitle: '', platformUsers: '', companyHeadquarters: '',
        message: '', marketingConsent: false
      });
       setFormErrors({}); // Clear errors on successful submission
    }
  };

  // --- INLINE STYLES ---
  const styles = {
    pageContainer: {
      ...commonStyles.container, // Base container styles
      paddingTop: '60px',
      paddingBottom: '60px',
      display: 'flex',
      flexDirection: 'row', // Side-by-side layout
      flexWrap: 'wrap', // Allow wrapping on smaller screens
      gap: '40px', // Gap between columns
      fontFamily: typography.fontFamily,
      color: colors.primaryText,
      boxSizing: 'border-box', // Ensure padding/border included in width/height
    },
    leftColumn: {
      flex: '1 1 350px', // Flex properties for responsiveness
      minWidth: '300px', // Prevent excessive shrinking
    },
    rightColumn: {
      flex: '1 1 450px', // Allow form to take more space
      minWidth: '350px',
    },
    mainTitle: {
      fontSize: typography.largeTitleSize, // Consistent large title size
      fontWeight: typography.normalWeight,
      lineHeight: 1.1,
      marginBottom: '30px',
      fontFamily: typography.fontFamily, // Ensure font (already in container, but good practice)
      color: colors.primaryText,
    },
    description: {
      fontSize: '1.1rem',
      marginBottom: '30px',
      color: colors.primaryText, // Use primary text color
      lineHeight: 1.6,
    },
    featureList: {
      listStyleType: 'none',
      padding: 0,
      margin: '0 0 30px 0',
    },
    listItem: {
      position: 'relative',
      paddingLeft: '30px', // Space for the checkmark
      marginBottom: '15px',
      fontSize: '1rem', // Standard text size
      lineHeight: 1.5,
    },
    checkIcon: {
      position: 'absolute',
      left: 0,
      top: '4px', // Adjust vertical alignment
      color: colors.accent, // Use accent color for checkmark
      fontWeight: typography.boldWeight,
    },
    badgeContainer: {
      display: 'flex',
      gap: '15px', // Slightly smaller gap
      marginBottom: '30px',
      alignItems: 'center',
    },
    badge: {
      width: '50px', // Smaller badges
      height: '50px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: `1px solid ${colors.border}`,
      borderRadius: '50%', // Circular badge
      fontSize: '0.75rem',
      fontWeight: typography.boldWeight,
      color: colors.secondaryText,
    },
    badgeGDPR: { // Specific style if needed, e.g., background
        // Example: If you want a background for one
        // backgroundColor: colors.accent,
        // color: colors.white,
        // border: 'none',
    },
    complianceText: {
      fontSize: '0.8rem',
      color: colors.secondaryText,
      lineHeight: 1.4,
      textTransform: 'uppercase', // Match original style
    },
    // Form Styles
    formGroup: {
      marginBottom: '20px',
      boxSizing: 'border-box',
    },
    formLabel: {
      display: 'block',
      marginBottom: '8px',
      fontWeight: typography.boldWeight,
      fontSize: '0.9rem',
      color: colors.primaryText,
    },
    inputFieldBase: { // Base styles for input, select, textarea
      width: '100%', // Use full width within container
      padding: '12px 18px', // Adjust padding
      borderRadius: '30px', // Keep pill shape if desired
      border: `1px solid ${colors.border}`,
      fontSize: typography.baseSize, // '1rem'
      fontFamily: typography.fontFamily,
      color: colors.primaryText,
      boxSizing: 'border-box', // Important for width: 100%
      transition: 'border-color 0.2s ease, box-shadow 0.2s ease', // Smooth transition
      outline: 'none', // Remove default outline
    },
    inputFieldFocus: { // Style applied on focus
      borderColor: colors.accent,
      boxShadow: `0 0 0 2px ${colors.accent}33`, // Subtle glow using alpha
    },
    selectField: { // Specific styles for select
        appearance: 'none', // Remove default arrow
        backgroundImage: 'url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%236b7280\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e")', // Use secondaryText color for arrow
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 18px center',
        backgroundSize: '1em', // Relative size
        paddingRight: '40px', // Make space for custom arrow
    },
    textArea: { // Specific styles for textarea
        resize: 'vertical',
        minHeight: '80px',
        borderRadius: '15px', // Less rounded for textarea
        width: '100%'
    },
    inputGroup: { // Container for side-by-side fields
      display: 'flex',
      gap: '20px',
      marginBottom: '20px',
      flexWrap: 'wrap', // Allow stacking on small screens
    },
    inputWrapper: { // Wrapper for individual field in a group
      flex: '1 1 200px', // Allows fields to grow and shrink
      minWidth: '180px', // Prevent excessive shrinking
      boxSizing: 'border-box',
    },
    errorMessage: {
      color: colors.error || 'red', // Use defined error color or default red
      fontSize: '0.85rem',
      marginTop: '5px',
    },
    checkboxGroup: {
        marginBottom: '25px',
    },
    checkboxLabel: {
      display: 'flex',
      alignItems: 'flex-start', // Align checkbox with start of text
      gap: '10px',
      cursor: 'pointer',
    },
    checkboxInput: {
      marginTop: '5px', // Align checkbox vertically
      flexShrink: 0, // Prevent checkbox from shrinking
       // Consider custom checkbox styling for better consistency (more complex)
       accentColor: colors.accent, // Modern way to color checkbox/radio
    },
    checkboxText: {
      fontSize: '0.9rem',
      color: colors.primaryText,
      lineHeight: 1.5,
    },
    submitButtonBase: {
      backgroundColor: colors.accent, // Use accent color
      color: colors.white,
      border: 'none',
      borderRadius: '30px', // Match input pill shape
      padding: '12px 30px', // Adjust padding
      fontSize: typography.baseSize,
      fontWeight: typography.boldWeight,
      fontFamily: typography.fontFamily,
      cursor: 'pointer',
      transition: 'background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease',
      display: 'inline-block', // Ensure it behaves like a block for margin/padding
      textAlign: 'center',
      transform: 'translateY(0)',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    submitButtonHover: { // Style applied on hover
      backgroundColor: colors.accentDark,
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
    },
  };
  // --- END INLINE STYLES ---

  // Helper function to get input style based on focus state
  const getInputStyle = (fieldName, baseStyle = styles.inputFieldBase) => {
      return focusedField === fieldName
        ? { ...baseStyle, ...styles.inputFieldFocus }
        : baseStyle;
  };


  return (
    <div style={styles.pageContainer}>
      {/* Left Column */}
      <div style={styles.leftColumn}>
        <h1 style={styles.mainTitle}>
          Your intro<br />
          to PlasticAnalytics
        </h1>
        <p style={styles.description}>
          Discuss use cases and explore the benefits of our microplastics analysis platform.
        </p>
        <ul style={styles.featureList}>
          <li style={styles.listItem}>
            <span style={styles.checkIcon}>✓</span>
            Advanced spectroscopic analysis for plastics identification and research.
          </li>
          <li style={styles.listItem}>
            <span style={styles.checkIcon}>✓</span>
            Comprehensive spectral library access to over 60 different plastic types across Raman and FTIR
          </li>
          <li style={styles.listItem}>
            <span style={styles.checkIcon}>✓</span>
              MicroplasticVision model and Spectral Imaging Suite access
          </li>
          <li style={styles.listItem}>
            <span style={styles.checkIcon}>✓</span>
            Third-party spectrometer integrations and API access
          </li>
        </ul>
        <div style={styles.badgeContainer}>
          <div style={styles.badge}>ISO</div>
          <div style={{...styles.badge, ...styles.badgeGDPR}}>GDPR</div>
        </div>
        <p style={styles.complianceText}>
          ISO 27001 CERTIFIED AND GDPR COMPLIANT. DATA ENCRYPTED
          AT REST WITH AES 256 AND IN TRANSIT WITH TLS 1.2+.
        </p>
      </div>

      {/* Right Column */}
      <div style={styles.rightColumn}>
        <form onSubmit={handleSubmit} noValidate> {/* Added noValidate to rely on JS validation */}
          {/* Work Email */}
          <div style={styles.formGroup}>
            <label style={styles.formLabel} htmlFor="workEmail">Work email*</label>
            <input
              id="workEmail"
              type="email"
              name="workEmail"
              value={formData.workEmail}
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              style={getInputStyle('workEmail')}
              required // Keep for browser hints, but validation enforces it
            />
            {formErrors.workEmail && <p style={styles.errorMessage}>{formErrors.workEmail}</p>}
          </div>

          {/* First/Last Name Group */}
          <div style={styles.inputGroup}>
            <div style={styles.inputWrapper}>
              <label style={styles.formLabel} htmlFor="firstName">First name*</label>
              <input
                id="firstName"
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                style={getInputStyle('firstName')}
                required
              />
              {formErrors.firstName && <p style={styles.errorMessage}>{formErrors.firstName}</p>}
            </div>
            <div style={styles.inputWrapper}>
              <label style={styles.formLabel} htmlFor="lastName">Last name*</label>
              <input
                id="lastName"
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                style={getInputStyle('lastName')}
                required
              />
              {formErrors.lastName && <p style={styles.errorMessage}>{formErrors.lastName}</p>}
            </div>
          </div>

          {/* Company/Job Title Group */}
          <div style={styles.inputGroup}>
             <div style={styles.inputWrapper}>
              <label style={styles.formLabel} htmlFor="companyName">Company name*</label>
              <input
                id="companyName"
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                style={getInputStyle('companyName')}
                required
              />
              {formErrors.companyName && <p style={styles.errorMessage}>{formErrors.companyName}</p>}
            </div>
            <div style={styles.inputWrapper}>
              <label style={styles.formLabel} htmlFor="jobTitle">Job title*</label>
              <input
                id="jobTitle"
                type="text"
                name="jobTitle"
                value={formData.jobTitle}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                style={getInputStyle('jobTitle')}
                required
              />
              {formErrors.jobTitle && <p style={styles.errorMessage}>{formErrors.jobTitle}</p>}
            </div>
          </div>

           {/* Platform Users/Headquarters Group */}
          <div style={styles.inputGroup}>
            <div style={styles.inputWrapper}>
              <label style={styles.formLabel} htmlFor="platformUsers">Platform users*</label>
              <select
                id="platformUsers"
                name="platformUsers"
                value={formData.platformUsers}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                style={{...getInputStyle('platformUsers'), ...styles.selectField}}
                required
              >
                <option value="" disabled>Please Select</option>
                <option value="1-10">1-10</option>
                <option value="11-50">11-50</option>
                <option value="51-200">51-200</option>
                <option value="201-500">201-500</option>
                <option value="501+">501+</option>
              </select>
              {formErrors.platformUsers && <p style={styles.errorMessage}>{formErrors.platformUsers}</p>}
            </div>
             <div style={styles.inputWrapper}>
              <label style={styles.formLabel} htmlFor="companyHeadquarters">Company headquarters*</label>
              <select
                id="companyHeadquarters"
                name="companyHeadquarters"
                value={formData.companyHeadquarters}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                style={{...getInputStyle('companyHeadquarters'), ...styles.selectField}}
                required
              >
                <option value="" disabled>Please Select</option>
                <option value="North America">North America</option>
                <option value="Europe">Europe</option>
                <option value="Asia">Asia</option>
                <option value="South America">South America</option>
                <option value="Africa">Africa</option>
                <option value="Australia/Oceania">Australia/Oceania</option>
                <option value="Other">Other</option>
              </select>
               {formErrors.companyHeadquarters && <p style={styles.errorMessage}>{formErrors.companyHeadquarters}</p>}
            </div>
          </div>

          {/* Message Textarea */}
          <div style={styles.formGroup}>
            <label style={styles.formLabel} htmlFor="message">Tell us more about how you want to use PlasticAnalytics AI*</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              rows="5" // Increased rows slightly
              style={{...getInputStyle('message', styles.textArea), ...styles.textArea}} // Combine base, focus, and specific textarea styles
              required
            />
             {formErrors.message && <p style={styles.errorMessage}>{formErrors.message}</p>}
          </div>

          {/* Marketing Consent Checkbox */}
          <div style={styles.checkboxGroup}>
            <label style={styles.checkboxLabel}>
              <input
                type="checkbox"
                name="marketingConsent"
                checked={formData.marketingConsent}
                onChange={handleChange}
                style={styles.checkboxInput}
                required
              />
              <span style={styles.checkboxText}>
                I agree to PlasticAnalytics sending me marketing communications, as described in the Privacy and Cookie policy*
              </span>
            </label>
             {formErrors.marketingConsent && <p style={styles.errorMessage}>{formErrors.marketingConsent}</p>}
          </div>

          {/* Submit Button */}
          <Button type="primary" >
          Book an intro
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;